var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullsizesuvBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.126,
    height: 68,
    viewBox: "0 0 107.126 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fullsizesuv-blue-icon",
    transform: "translate(-245.874 -575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Full_Size_SUV",
    "data-name": "Full Size SUV",
    transform: "translate(250 639)",
    fill: "#04a8e8",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FULL SIZE SUV")), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(-1477.061 -1839.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M1793.5,2414.767c8.211,0,16.424.045,24.634-.035a3.368,3.368,0,0,1,3.452,2.221c2.759,5.786,5.276,11.642,6.039,18.094.132,1.113.148,2.152,1.465,2.912s1.234,8.9.114,10.006a3.12,3.12,0,0,1-2.683.694c-1.141-.143-.96-1.184-1.078-2.017-.941-6.615-5.32-10.788-11.331-10.833-5.794-.043-10.309,4.032-11.307,10.507-.291,1.894-.976,2.47-2.835,2.461q-21.93-.088-43.861,0c-1.975.009-2.458-.744-2.667-2.591a11.321,11.321,0,0,0-11.077-10.38c-5.856-.132-10.606,4.041-11.448,10.329-.241,1.8-.655,2.851-2.652,2.606s-4.453.63-5.061-2.519c-.964-5,.921-9.582,1.99-14.273.32-1.4,1.862-1.584,3.11-1.909,7.149-1.859,14.489-2.419,21.8-3.159,1.807-.183,3.355-.668,4.368-2.2,5.379-8.129,13.188-10.328,22.441-9.692,5.507.377,11.06.069,16.592.069Zm-12.234,2.944c-3.808,0-7.409.243-10.965-.055-5.684-.479-9.1,2.589-12.1,6.972,2.12.432,4.318.667,3.836,3.31,5.385,0,10.589,0,15.792,0a1.947,1.947,0,0,0,2.134-1.887C1780.377,2423.332,1780.811,2420.613,1781.265,2417.711Zm1.923,10.269h10.949c8.917,0,9.116-.333,5.9-8.675a2.762,2.762,0,0,0-3.039-2.135c-3.5.137-7.013.158-10.52.2-1.459.017-2.493.5-2.629,2.115C1783.629,2422.116,1782.9,2424.708,1783.188,2427.98Zm21.467-10.718c.756,3.664,2.412,6.5,3.747,9.447a2.021,2.021,0,0,0,1.822,1.134c4.214.024,8.428.011,12.859.011-.408-3.751-1.971-6.643-3.3-9.609a1.656,1.656,0,0,0-1.551-.963C1813.809,2417.244,1809.387,2417.262,1804.655,2417.262Z",
    transform: "translate(0 0)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M1827.758,2460.435c-4.96.433-8.979-5.49-8.8-9.485a9.27,9.27,0,0,1,9.454-8.861,9.132,9.132,0,0,1,8.777,9.166A9.319,9.319,0,0,1,1827.758,2460.435Z",
    transform: "translate(-13.992 -3.986)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M1743.954,2460.465a9.191,9.191,0,0,1-9.1-9.47,9.058,9.058,0,0,1,18.115.229A9.283,9.283,0,0,1,1743.954,2460.465Z",
    transform: "translate(-1.736 -3.988)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullsizesuvBlueIcon);
export default __webpack_public_path__ + "static/media/fullsizesuv-blue-icon.086e75354df70cdba0724b6e8f7fd6d8.svg";
export { ForwardRef as ReactComponent };